export const Type = {
  FORGET_PASS_GET_CODE: "otpGetCode",
  FORGET_PASS_GET_CODE_SUCCSESS: "otpGetCodeSuccsess",
  FORGET_PASS_VERIFY: "otpVerify",
  FORGET_PASS_RESET_REMIND_TIME: "otpResetRemindTime",
  FORGET_PASS_VERIFY_SUCCSESS: "otpVerifySuccsess",
};
